import { render, staticRenderFns } from "./InsideRequestIcon.vue?vue&type=template&id=e022044e&"
import script from "./InsideRequestIcon.vue?vue&type=script&lang=js&"
export * from "./InsideRequestIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports